// src/components/trial/lp/trial-beta/sections/stats.tsx
// Ported from the design attachment, markup lines 3958-4011. Purely static: the source's
// `data-anim="stat-counter"` count-up-on-scroll behavior is out of this task's scope (the brief
// lists Stats among the sections with "no bespoke animation beyond the marquee and the FAQ
// accordion"), but the attribute is kept on the value node so a later task can wire the counter
// against it without touching this markup again.
import { useTranslation } from 'next-i18next';

interface StatItem {
  emoji: string;
  value: string;
}

// Values are numbers/percentages, not language content — kept literal here the same way hero.tsx
// hardcodes its own stat pills ("80%", "110%", "6+", "5+") and only translates their labels.
const STAT_ITEMS: readonly StatItem[] = [
  { emoji: '📡', value: '80%' },
  { emoji: '🔨', value: '110%' },
  { emoji: '👥', value: '3M' },
  { emoji: '🌐', value: '2000' },
];

export function Stats() {
  const { t } = useTranslation('components/trial/lp/trial-beta');

  return (
    <section id='stats' className='relative px-4 py-14 md:px-8 md:py-20' style={{ zIndex: 1 }}>
      <div className='relative mx-auto max-w-6xl' style={{ zIndex: 1 }}>
        <div className='mb-10 text-center md:mb-14'>
          <span className='mb-3 block text-xs font-semibold uppercase tracking-[0.3em] md:text-sm' style={{ color: '#2ECDFF', fontFamily: 'var(--font-outfit)' }}>
            {t('stats.eyebrow')}
          </span>
          <h2 className='mb-4 text-3xl font-bold md:text-5xl' style={{ fontFamily: 'var(--font-bai)', color: '#E5E7EB' }}>
            {t('stats.title')} <span style={{ color: '#2ECDFF' }}>{t('stats.titleHighlight')}</span>
          </h2>
        </div>
        <div className='grid grid-cols-2 gap-4 md:grid-cols-4'>
          {STAT_ITEMS.map((statItem, statIndex) => (
            <div key={statItem.value} className='group relative'>
              <div className='relative overflow-hidden rounded-xl border p-6 text-center transition-all duration-300 hover:shadow-lg' style={{ borderColor: '#2ECDFF30', background: 'linear-gradient(to bottom, #2ECDFF10, #12121A)' }}>
                <div className='absolute start-0 top-0 size-4 rounded-ss-lg border-s-2 border-t-2' style={{ borderColor: '#2ECDFF50' }} />
                <div className='absolute end-0 top-0 size-4 rounded-se-lg border-e-2 border-t-2' style={{ borderColor: '#2ECDFF50' }} />
                <div className='absolute bottom-0 start-0 size-4 rounded-es-lg border-b-2 border-s-2' style={{ borderColor: '#2ECDFF50' }} />
                <div className='absolute bottom-0 end-0 size-4 rounded-ee-lg border-b-2 border-e-2' style={{ borderColor: '#2ECDFF50' }} />
                <div className='mb-3 text-3xl' aria-hidden='true'>
                  {statItem.emoji}
                </div>
                <div data-anim='stat-counter' className='mb-1 text-2xl font-black md:text-3xl' style={{ color: '#93FF18', fontFamily: 'var(--font-outfit)' }}>
                  {statItem.value}
                </div>
                <div className='text-sm uppercase tracking-wider' style={{ color: '#929298' }}>
                  {t(`stats.items.${statIndex}.label`)}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
